// extracted by mini-css-extract-plugin
export default {"noDataView":"TotalSummary_noDataView__qcP4i"};